import { applyMiddleware, createStore } from 'redux'
import rootReducer from '../../js/reducers/index'
import promiseMiddleware from 'redux-promise-middleware'
// import logger from 'redux-logger' TODO: to be used in the feature if needed - add to the middleware parameters

const store = createStore(rootReducer, applyMiddleware(promiseMiddleware))

export default store
